import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ReferenceDataService } from '../services/reference-data.service';

@Directive({
  selector: '[boiRequiredFormField]'
})
export class RequiredFormFieldDirective implements OnInit {
  @Input() boiRequiredFormField: string;
  @Input() forceRequired: boolean;
  @Input() forceNotRequired: boolean;

  constructor(
    public referenceDataService: ReferenceDataService,
    private readonly hostElement: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (
      this.forceRequired ||
      (!this.forceNotRequired && this.referenceDataService.isFieldRequired(this.boiRequiredFormField))
    ) {
      this.renderer.addClass(this.hostElement.nativeElement, 'mandatory');
    }
  }
}
